export type ContentErrorCode =
  | 'network'
  | 'timeout'
  | 'not-found'
  | 'rate-limit'
  | 'http'
  | 'invalid'
  | 'parse'

export interface ContentErrorOptions {
  readonly status?: number
  readonly retryAfter?: string
}

export class ContentError extends Error {
  readonly code: ContentErrorCode
  readonly status?: number
  readonly retryAfter?: string

  constructor(code: ContentErrorCode, message: string, options: ContentErrorOptions = {}) {
    super(message)
    this.name = 'ContentError'
    this.code = code
    this.status = options.status
    this.retryAfter = options.retryAfter
  }
}

export function asContentError(error: unknown): ContentError {
  if (error instanceof ContentError) return error
  if (error instanceof Error) return new ContentError('network', error.message)
  return new ContentError('network', String(error))
}
